import { ReactElement } from 'react';
import { AwsClientOverrides, getSchema } from '@localstack/services';
import {
  CreateWebFunctionEndpointRequest,
  GetWebFunctionEndpointResponse,
  UpdateWebFunctionEndpointRequest,
} from '@localstack/types';

import { RelatedResourcePicker } from '@localstack/ui';

import { MagicForm } from '../../magic/MagicForm';

export interface LambdaWebEndpointFormProps {
  formId: string;
  functionName: string;
  endpoint?: Partial<GetWebFunctionEndpointResponse>;
  loading?: boolean;
  clientOverrides?: AwsClientOverrides;
  onCreate: (data: CreateWebFunctionEndpointRequest) => unknown;
  onUpdate: (data: UpdateWebFunctionEndpointRequest) => unknown;
}
export const LambdaWebEndpointForm = ({
  formId,
  functionName,
  endpoint,
  loading,
  clientOverrides,
  onCreate,
  onUpdate,
}: LambdaWebEndpointFormProps): ReactElement => (
  <MagicForm
    schema={getSchema('LambdaWeb')}
    entry={endpoint ? 'UpdateWebFunctionEndpointRequest' : 'CreateWebFunctionEndpointRequest'}
    formId={formId}
    loading={loading}
    data={endpoint}
    defaultValues={{ autoDeploymentMode: 'LatestRevision' }}
    fieldConditions={{
      '^functionName$': false,
      '^(scalingConfig|throttleConfig)$': false,
      '^endpointName$': !endpoint,
      '^regions$': ['$endpointType', 'in', ['MultiRegion', 'PerRegion']],
      '^revisionWeights$': ['$autoDeploymentMode', '===', 'Disabled'],
    }}
    externalFields={{
      '^revisionWeights\\.\\d+\\.revisionId$': (control, fieldName, required) => (
        <RelatedResourcePicker
          control={control}
          fieldName={fieldName}
          client="LambdaWeb"
          method="listWebFunctionRevisions"
          args={[{ functionName }]}
          arrayKeyName="revisions"
          pagination={{ inputToken: 'nextToken', outputToken: 'nextToken', itemsKey: 'revisions' }}
          property="revisionId"
          entityName="Revision"
          clientOverrides={clientOverrides}
          required={required}
        />
      ),
    }}
    onSubmit={(data: CreateWebFunctionEndpointRequest | UpdateWebFunctionEndpointRequest) =>
      endpoint ? onUpdate(data) : onCreate(data as CreateWebFunctionEndpointRequest)
    }
  />
);
